import React from "react";
import { useTranslation } from "react-i18next";
import previewIcon from "../../../assets/img/save_export/preview-dark.svg";

export default function SupplierPdfActions({ order, busy, onUnpriced, onPriced }: {
  order: any; busy?: boolean;
  onUnpriced: (download: boolean) => void;
  onPriced: (download: boolean) => void;
}) {
  const { t } = useTranslation("supplierPricing");
  const incoming = order.is_creater === false;
  return <div className="supplier-pdf-actions">
    {([false, true] as const).map(priced =>
      <button key={String(priced)} type="button"
        disabled={busy || (priced && incoming)}
        onClick={() => priced ? onPriced(false) : onUnpriced(false)}>
        <img src={previewIcon} alt="" aria-hidden="true" />
        <span>{t(`order.${priced ? "priced" : "unpriced"}Preview`)}</span>
      </button>
    )}
    {incoming && <p className="supplier-pdf-unavailable" role="note">{t("order.ownerRequired")}</p>}
  </div>;
}
